import IconAlert from "components/common/IconAlert";

export default function ErrorMessage({ message, setShow }) {

    return (
        <IconAlert variant="danger" dismissible onClose={() => setShow(false)}>
            <p className="mb-0">{message}</p>
        </IconAlert>
    );
}